import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../utility/Redux/security';
import {
  selectPrefix,
  selectTableMasterPrefix,
  selectWidth,
} from '../utility/Redux/profile';
import { useState } from 'react';

import axios from 'axios';
import { useEffect } from 'react';
import { useFocus } from '../utility/hooks/hooks';
import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import GeniustextInput from '../utility/component/mastertext';
import {
  ModifyButton,
  SaveButton,
  UndoButton,
} from '../utility/component/SNAA_buttons';
import GeniusDatagrid from '../utility/component/datagrid.js/geniusDatagrid';
import { useNavigate } from 'react-router-dom';
import { toProperCase } from '../utility/component/format';
import { CallAPIPromise } from '../utility/func/func';
import { ApartmentOutlined, Close, FormatListBulletedRounded } from '@mui/icons-material';
import './departmentMaster.css';

const DepartmentMaster = () => {
  const dispatch = useDispatch();
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const windowWidth = useSelector(selectWidth);
  const [id, setId] = useState();
  const [secName, setSecName] = useState();
  const [rows, setRows] = useState([]);
  const [secError, setSecError] = useFocus();

  const columns = [
    {
      field: 'DEPARTMENT_NAME',
      type: 'string',
      renderHeader: (params) => <div>Department Name</div>,
      width: windowWidth > 764 ? 400 : 300,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => {
        const runningCaseValue = params.value;
        return <div>{runningCaseValue}</div>;
      },
    },
  ];
  const masterPrefix = useSelector(selectTableMasterPrefix);

  const getData = async () => {
    // dispatch(setSpinnerLoading('Loading'));
    dispatch(setSpinnerLoading('Loading'));
    const data = {
      table_prefix_master: masterPrefix,
      DEPARTMENT_NAME: '',
    };
    CallAPIPromise('/api/masters/listDepartmentMaster', data)
      .then((p) => {
        setRows(p.data.response);
      })
      .catch((error) => {
        console.log(error.response.data.name);
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
          console.log(error.response);
        }
      })
      .finally(() => {
        setSecError();
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    getData();
  }, []);
  const saveSectionMasterApi = () => {
    if (secName) {
      const isDuplicateMobile = rows.some(
        (row) => row.DEPARTMENT_NAME === secName
      );

      if (isDuplicateMobile) {
        dispatch(
          setAlertWithTitle({
            title: 'Information Error!',
            msg: 'This Department is already exists. Please choose a different Department.',
          })
        );
        return;
      }

      const data = {
        table_prefix_master: masterPrefix,
        CODE: id ? id : '',
        DEPARTMENT_NAME: secName,
      };

      id
        ? dispatch(setSpinnerLoading('Updating'))
        : dispatch(setSpinnerLoading('Saving'));
      CallAPIPromise(`/api/masters/saveDepartmentMaster`, data)
        .then(async function (response) {
          if (!response.data.error) {
            id
              ? dispatch(
                  setAlertWithTitle({
                    title: 'Success.',
                    msg: 'Data Updated successfully.',
                    lottie: 'success',
                  })
                )
              : dispatch(
                  setAlertWithTitle({
                    title: 'Success.',
                    msg: 'Data Saved successfully.',
                    lottie: 'success',
                  })
                );
          } else {
            dispatch(
              setAlertWithTitle({
                title: 'Error 112',
                msg: response.data.error,
              })
            );
            console.log(!response.data.error);
          }
        })
        .catch(function (error) {
          if (error.response.data.name === 'TokenExpiredError') {
            dispatch(setSessionExpired(true));
            console.log(error.response);
          }
          console.log(error);
          dispatch(
            setAlertWithTitle({
              title: 'ERROR',
              msg: 'Something went wrong.',
              lottie: 'reject',
            })
          );
        })
        .finally(() => {
          dispatch(setSpinnerLoading(false));
          setSecName('');
          setId('');
          getData();
        });
    } else {
      if (!secName) {
        dispatch(
          setAlertWithTitle({
            title: 'ERROR',
            msg: 'Please Enter Department Name.',
            lottie: 'reject',
          })
        );
        setSecError();
      }
    }
  };
  const navigate = useNavigate();
  return (
    <main className="department-master-page">
      <div className="department-master-shell">
        <header className="department-master-hero">
          <div className="department-master-hero__content"><span className="department-master-hero__icon"><ApartmentOutlined /></span><div><span>Team & production</span><h1>Department Master</h1><p>Set up departments for a clear production workflow.</p></div></div>
          <button type="button" onClick={() => navigate('/masters')} aria-label="Back to Masters" title="Back to Masters"><Close fontSize="small" /></button>
        </header>

        <section className="department-master-card department-master-entry">
          <div className="department-master-card__heading"><div><span>Department details</span><h2>{id ? 'Update department' : 'Create a department'}</h2></div><small>{id ? 'Editing selected department' : 'New department'}</small></div>
          <div id="input" className="department-master-entry__body">
            <div className="department-master-input">
            <GeniustextInput
              title={'Department Name'}
              width={'100%'}
              type={'text'}
              //   search={handleOpenDeptHelp}
              value={secName}
              onChange={(e) => {
                setSecName(toProperCase(e.target.value));
              }}
              refrance={secError}
            />
            </div>
            <div className="department-master-actions">
              {id ? <ModifyButton onClick={saveSectionMasterApi} /> : <SaveButton onClick={saveSectionMasterApi} />}
              <UndoButton onClick={() => { setSecName(''); setId(''); }} />
            </div>
          </div>
        </section>

        <section className="department-master-card department-master-table-card">
          <div className="department-master-card__heading"><div><span>Saved departments</span><h2>Department catalogue</h2></div><small className="department-master-count"><FormatListBulletedRounded fontSize="small" /> {rows.length} departments</small></div>
          <div className="department-master-grid">
            <GeniusDatagrid
              rowID={(e) => e.CODE}
              onRowClick={(p) => {
                setId(p.row.CODE);
                setSecName(p.row.DEPARTMENT_NAME);
              }}
              columns={columns}
              list={rows}
            />
          </div>
        </section>
      </div>
    </main>
  );
};

export default DepartmentMaster;
